import React from "react"

const FooterView = () => {
    return (
<footer className="bg-white border-t border-gray-200 font-sans">
  <div className="container mx-auto px-4 py-6 text-center">
    <img
      src="/assets/images/main_logo.png"
      alt="The REAL 로고"
      className="mx-auto w-32 h-14 mb-4"
    />
    <p className="text-gray-600 text-xs sm:text-sm mb-2 whitespace-pre-wrap">
      주식회사 더리얼 | 서울특별시 강남구 도산대로 506, 7층(재정빌딩) | 
      sonmagic@realmkt.co.kr | 02-540-3111 | 대표이사: 손종희
    </p>

    <p className="text-gray-500 text-xs sm:text-sm">
      Copyright ⓒ The Real All rights reserved.
    </p>
  </div>
</footer>

    )
}

export default FooterView;